import { createEntityAdapter } from '@reduxjs/toolkit';
import { Upload } from '../entities/Upload';

export const uploadsAdapter = createEntityAdapter<Upload>();
